 <!-- eslint-disable vue/valid-v-model -->
 <!-- eslint-disable vue/no-unused-vars-->
 
<template>
  <div>
    <!-- <BlockUI :blocked="blockedDocument" :fullScreen="true">
      <ProgressSpinner v-if="blockedDocument" />
    </BlockUI> -->
    <div v-if="blockedDocument">
      <LoadingArete />
    </div>
    <Toolbar  style="padding: 4px; !important" class="p-mb-12">
      <template #left>
            <Button
              v-if="$route.params.formid != null"
              label=""
              icon="pi pi-arrow-left"
              class="p-button-link p-mr-2"
              @click="backto()"
            />
            <div v-if="selectedform != null" class="p-mt-2">
            <span class=" p-mt-2">
              <label class="formlabel p-mr-1" ><h5>{{selectedform.name}} </h5></label>
              <label class="formlabel p-mr-1" style="font-weight: 700;color: darkgray;font-size: 15px;" v-if="selectedform.application != null"> [{{ selectedform.application.name }}]</label>
            </span>
            <span class="p-mr-1 p-mr-6" ><i class="pi pi-info-circle p-mr-2" style="font-size: 15px" v-tooltip.bottom="selectedform.description"></i></span>

            <span v-if="selectedform.statusName != null"
              :class="'customstatus ' + selectedform.statusName.toLowerCase()"
              class="p-mr-6"
              style="padding-bottom:0px !important"
            >
              <label class="formlabel">Form Status :</label>
              {{ selectedform.statusName }}
            </span>  
             </div>        
      </template>
      <template #right>
        <span v-if="selectedform != null">
          <Button
            v-if="selectedform.statusName != null && selectedform.statusName.toLowerCase() == `draft` && selectedform.isPublishedForm && !isPreview"
            icon="pi pi-undo"
            class="p-button-rounded p-button-danger p-mr-2"
            v-tooltip.bottom="'Revert Back to Published Form'"
            @click="showRevertBackDialog()"
          /></span>
          <Button
            v-if="isPreview"
            label=""
            icon="pi pi-th-large"
            class="p-button-rounded p-button-help p-mr-2"
            v-tooltip.bottom="'Back To Builder'"
            @click="formbuilder()"
          />
          <Button
            v-else
            label=""
            icon="pi pi-eye"
            class="p-button-rounded p-button-help p-mr-2"
            v-tooltip.bottom="'Preview'"
            @click="formpreview()"
          />
          <Divider
          :hidden="isPreview || !selectedform"
          layout="vertical"
          >
          </Divider>
          <Button
            v-if="selectedform != null && selectedform.statusName != null &&
              selectedform.statusName.toLowerCase() == `draft` &&
              !isPreview &&
              !selectedform.application.skipApproval &&
              isFormCreaterAsReviewer 
            "
            label=""
            icon="pi pi-check"
            class="p-button-rounded p-button-secondary p-mr-2"
            v-tooltip.bottom="'Request for Review'"
            @click="statusConfirmation('requestForReview','Submitted')"
          />
          <Button
            v-if="!isPreview"
            label=""
            icon="pi pi-save"
            class="p-button-rounded p-button-info p-mr-2"
            v-tooltip.bottom="'Save as Draft'"
            @click="saveAsDraft()"
          />
          <Button
            v-if="selectedform != null && selectedform.statusName != null &&
              selectedform.statusName.toLowerCase() == `draft` &&
              selectedform.application.skipApproval &&
              !isPreview &&
              isFormCreaterAsPublisher
            "
            label=""
            icon="pi pi-upload"
            class="p-button-rounded p-button-success p-mr-2"
            v-tooltip.bottom="'Publish Form'"
            @click="statusConfirmation('requestForPublish', 'Published')"
          />
          <Divider
          :hidden="isPreview || !selectedform"
          layout="vertical"
          >
          </Divider>
          <Button
            v-if="!isPreview"
            icon="pi pi-arrow-circle-up"
            class="p-button-rounded p-button-success p-mr-2"
            v-tooltip.bottom="'Import Form Schema'"
            @click="showUpdateSchemaDialog()"
          />
          <Button
            v-if="!isPreview"
            icon="pi pi-copy"
            class="p-button-rounded p-button-warning p-mr-2"
            id="copy"
            @click="tooltipText = 'Form Schema Copied'"
            @mouseout="tooltipText = 'Copy to Clipboard'"
            v-clipboard:copy="JSON.stringify(rebuildForm)"
          />
          <b-tooltip target="copy" placement="bottom">
            <span style="font-size: 14px !important"> {{ tooltipText }}</span>
          </b-tooltip>
      </template>
    </Toolbar>
    <div class=" stickdiv" v-if="!isPreview">
      <div style="margin: 8px -1% 8px 72%;" class="">The Form Builder allows you to build: <Dropdown class="filter-width" v-model="selectedformType" :options="formType"  placeholder="Select a Form Type" @change="changeFormType" /></div>
    </div>
    <div id="componentFormBuilder" v-if="!blockedDocument">
      <div class="formbuilder">
        <div v-if="isPreview"><formio class="p-field p-col-12 p-md-12"
                              :key="componentKey"
                              v-bind:form="form"
                              v-bind:options="options"
                              v-bind:formLoad="onFormRendered"
                              id="formio"
                              ref="formioForm"></formio></div>
        <div v-else>
          <formbuilderio :form="form" :options="options" ref="formRefValue"></formbuilderio>
        </div>
      </div>
    </div>
    <Dialog
      v-if="updateSchemaDialog"
      :visible.sync="updateSchemaDialog"
      header="Import Form Schema"
      :modal="true"
      :style="{ width: '60vw' }"
    >
      <div class="p-fluid p-grid">
        <div class="p-field p-col-12">
          <label for="schema">Enter Form Schema Object</label>
          <Textarea
            id="schema"
            v-model="updateSchemaObj"
            :autoResize="true"
            rows="7"
            cols="12"
            placeholder="Enter Form Schema Object"
            required="true"
            :class="{ 'p-invalid': !updateSchemaObj }"
          /><span
            :class="{ 'p-invalid': !updateSchemaObj }"
            v-if="!updateSchemaObj"
            class="error-message"
            >Form Schema object is Required</span
          >
          <span
            :class="{ 'p-invalid': !updateSchemaObj }"
            v-if="!isJson(updateSchemaObj) && updateSchemaObj"
            class="error-message"
            >Enter Valid Form Schema Object</span
          >
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          @click="closeDialog()"
          class="p-button-text"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          @click="updateFormSchama()"
          class="p-button-text"
          autofocus
          :disabled="!isJsonFlag"
        />
      </template>
    </Dialog>
    <Dialog
      v-if="fbconfirm"
      :visible.sync="fbconfirm"
      header="Confirmation"
      :modal="true"
      :style="{ width: '30vw' }"
    >
      <div class="p-fluid p-grid">
        <div class="confirmation-content">
          <i
            class="pi pi-exclamation-triangle p-mr-3"
            style="font-size: 2rem"
          />
          <span>{{ dialogContent }}</span>
        </div>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeDialog()"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="saveFormSchema()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
    <Dialog
      v-if="displayConfirmation"
      :visible.sync="displayConfirmation"
      header="Confirmation"
      :modal="true"
      :style="{ width: '50vw' }"
    >
      <div class="confirmation-content">
        <div>
          <span>{{ confirmContent }}</span>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 mt-3">
            <label for="formRemark"
              >Remark<span class="p-invalid">*</span></label
            >
            <Textarea
              :autoResize="true"
              rows="3"
              cols="7"
              placeholder="Form Remark"
              required="true"
              v-model="remark"
              :class="{ 'p-invalid':submitted && !remark }"
            /><span
              :class="{ 'p-invalid': !remark }"
              v-if="submitted && !remark"
              class="error-message"
              >Remarks/Comments are Required</span
            >
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation()"
          class="p-button-text"
        />
        <Button v-if="selectedAction == 'requestForPublish'"
          label="Yes"
          icon="pi pi-check"
          @click="requestForPublish('request_for_publish')"
          class="p-button-text"
          autofocus
        />
        <Button v-if="selectedAction == 'requestForReview'"
          label="Yes"
          icon="pi pi-check"
          @click="requestForReview('request_for_review')"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
    <Dialog
      v-if="isRevertBack"
      :visible.sync="isRevertBack"
      header="Confirmation"
      :modal="true"
      :style="{ width: '30vw' }"
    >
      <div class="p-fluid p-grid">
        <div class="confirmation-content">
          
          <span>Are you sure, you want to revert back to the published form ? </span>
        </div>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeDialog()"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="revertBackToPublishedForm()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import _ from "lodash";
import { FormBuilder, Form } from "vue-formio";
import { logCustomEvent,logException } from '../../services/logsToAppInsightsService';

export default {
  name: "formbuilderComponent",
  components: { formbuilderio: FormBuilder, formio: Form },
  created() {
    this.loading = true;
    this.loadedForm = _.clone(this.$store.getters["forms/getSelectedForm"]);
    this.selectedFormId = this.loadedForm.id;
    this.getForms();
  },
  data() {
    return {
      tooltipText: null,
      blockedPanel: false,
      blockedDocument: false,
      displayConfirmation: false,
      remark: null,
      submitted: false,
      isJsonFlag: false,
      rebuildForm: {
        components: [],
      },
      options: {
        builder: {
          premium: false,
            custom: {
            title: "Custom Fields",
            weight: 10,
            components: {
              firstName: {
                title: "File",
                key: "file",
                icon: "file",
                schema: {
                  label: "File",
                  type: "file",
                  key: "file",
                },
              }
            },
          },
          resources: {
            title: "Resource Fields",
            weight: 10000,
            groups: {},
          },
        },
      },
      form: {},
      selectedform: null,
      //formid: this.$route.params.formid,
      formid: this.selectedFormId
        ? this.selectedFormId
        : this.$route.params.formid,
      isPreview: false,
      fbconfirm: false,
      dialogContent: null,
      forms: {},
      resources: [],
      groups: [],
      savetype: null,
      loadedForm: {},
      selectedFormId: null,
      loadedFormId: null,
      loading: false,
      isFormCreaterAsPublisher: false,
      isFormCreaterAsReviewer: false,
      updateSchemaDialog: false,
      updateSchemaObj: null,
      tooltipMsg: "Copy form schema",
      isRevertBack: false,
      selectedformType: null,
      formType: ['Form','Wizard'],
      onLoadFormType: null,
      componentKey: 0,
      form_error: false
    };
  },
  mounted() {},
  methods: {
    // statusConf(name,msg){
    //   this.$refs.customModal.statusConfirmation(name,msg);
    // },
    async onFormRendered() {
      // console.log("Form is rendered");
    },
    changeFormType(){
      // alert(this.selectedformType);
      this.getForms();
    },
    isJson(item) {
      item = typeof item !== "string" ? JSON.stringify(item) : item;
      this.isJsonFlag = false;
      try {
        item = JSON.parse(item);
      } catch (e) {
        return false;
      }
      if (typeof item === "object" && item !== null) {
        this.isJsonFlag = true;
        return true;
      }
      return false;
    },
    showUpdateSchemaDialog() {
      this.updateSchemaDialog = true;
    },
    async getSelectedform() {
      let that = this;
      //let formid = this.formid;
      that.loading = true;
      let formid = this.selectedFormId ? this.selectedFormId : this.formid;
      that.blockedDocument = true;
      that.$store
        .dispatch("forms/getSelectedform", formid)
        .then(() => {
          let response = _.clone(that.$store.getters["forms/getSelectedForm"]);
          this.selectedform = _.clone(response);
          if (response.schema) {
            that.rebuildForm.components = _.clone(response.schema.components);
            that.form = that.rebuildForm;
          }
          that.getForms();
          //that.blockedDocument = false;
          that.loading = false;
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error while fetching the application form",
            detail: error.response.data,
            group: "br",
            life: 3000,
          });
        });
    },
    async updateFormSchama() {
      // console.log("Update Form Schema invoked");
      // this.validateFrom(str);
      // console.log(this.updateSchemaObj);
      if (this.updateSchemaObj != undefined) {
        let schema = JSON.parse(this.updateSchemaObj);
        let formId = this.selectedFormId ? this.selectedFormId : this.formid;

        await this.saveFormSchema(formId, schema);

        this.$toast.add({
        severity: "success",
        summary: "Success Message",
        detail: "Form saved successfully",
        life: 1000,
        });

        this.updateSchemaDialog = false;
        this.updateSchemaObj = null;

        await this.getSelectedform();
      }
    },
    async saveAsDraft() {
      //let forminput = this.formSchemaInput();

      let formId = this.selectedFormId ? this.selectedFormId : this.formid;

      await this.saveFormSchemaByFormId(formId);

      this.$toast.add({
        severity: "success",
        summary: "Success Message",
        detail: "Form saved successfully",
        life: 1000,
      });

      await this.getSelectedform();
    },
    async saveFormSchemaByFormId(formId) {
      await this.saveFormSchema(
        formId,
        this.$refs.formRefValue.builder.instance.schema
      );
    },
    async saveFormSchema(formId, formSchema) {
      let that = this;
      try{

      that.blockedDocument = true;
      that.submitted = true;
      that.loading = true;

      _.forEach(formSchema?.components, function(c){
        if(c.key == "submit" && c.type == "button"){
          if(!('url' in c)){
            c.url = ""
          }
        }
      })

      let input = {
        id: formId,
        schema:btoa(formSchema),
      };

      await that.$store.dispatch("forms/saveFromSchema", input);

      that.loading = false;
      that.blockedDocument = false;
    } catch(error){
      logException('Http Error', error.response);
      const token = await that.$store.dispatch('login/acquireTokenSilent');
      let input = {
        id: formId,
        schema: formSchema,
      };
      if (!token) {
        logCustomEvent('FORM_BUILDER_SCREEN', 'Save Form Schema Failed due to token expired', { ERROR: error.response });
        that.$store.dispatch('login/logout');
      } else {
        await that.$store.dispatch("forms/saveFromSchema", input);
      }
    }
    },
    async requestForReview() {
      this.validateForm('request_for_review')
      this.submitted = true;
      if(this.form_error){
        
      
      let that = this;
      //let forminput = this.formSchemaInput();

      let formId = this.selectedFormId ? this.selectedFormId : this.formid;

      await that.saveFormSchemaByFormId(formId);

      let selectedForm = that.$store.getters["forms/getSelectedForm"];
      let loggedUser = that.$store.getters["login/getUser"];

      // console.log(selectedForm);
      let input = {};
      input.formid = that.selectedFormId ? that.selectedFormId : that.formid;

      await that.$store.dispatch("forms/requestForReview", input);

      this.$toast.add({
        severity: "success",
        summary: "Success Message",
        detail: "Form Submitted Successfully",
        life: 1000,
      });
      this.submitted = false;
      await this.getSelectedform();
      selectedForm.application.reviewers.forEach((r) => {
        if (r.email == loggedUser.email) {
          this.$router.push("/formpreview/" + input.formid);
        }
      });
      that.loading = false;
    }
    },
    async requestForPublish() {
      this.validateForm('request_for_publish');
      this.submitted = true;
      if(this.form_error){
      let that = this;
      try{
        if (this.remark != undefined) {
        let formId = this.selectedFormId ? this.selectedFormId : this.formid;

        await this.saveFormSchemaByFormId(formId);
        let input = {};
        input.formid = that.selectedFormId ? that.selectedFormId : that.formid;
        input.remark = that.remark;
        await that.$store.dispatch("forms/requestForPublish", input);
        this.$toast.add({
          severity: "success",
          summary: "Success Message",
          detail: "Form Published Successfully",
          life: 1000,
        });
        this.getSelectedform();
        that.displayConfirmation = false;
        that.loading = false;
        this.submitted = false;
      }
      }catch (error) {
            //console.log(error);
          this.$toast.add({
          severity: "error",
          summary: "Error Message",
          detail: error.message,
          life: 1000,
        });
        }
      }
    },

    backto() {
      if(!this.isPreview){
        this.$router.push("/forms");
        this.blockedDocument = false;
      } else {
        this.isPreview = false;
      }
    },

    formpreview() {
      this.isPreview = true;
    },

    formbuilder() {
      this.isPreview = false;
    },

    formbuildercnf(type) {
      this.saveType = type;
      this.dialogContent =
        this.saveType === "save"
          ? "Do you want to save as Draft"
          : "Do you want to submit for Review";
      this.fbconfirm = true;
    },

    closeDialog() {
      this.saveType = null;
      this.fbconfirm = false;
      this.updateSchemaDialog = false;
      this.updateSchemaObj = null;
      this.isRevertBack = false;
    },

    getForms() {
      let that = this;
      //let formid = this.formid;
      that.loading = true;
      that.isFormCreaterAsPublisher = false;
      that.isFormCreaterAsReviewer = false;
      let formid = this.selectedFormId ? this.selectedFormId : this.formid;
      that.blockedDocument = true;
      that.$store
        .dispatch("forms/getSelectedform", formid)
        .then(() => {
          let response = _.clone(that.$store.getters["forms/getSelectedForm"]);
          that.selectedform = _.clone(response);
          that.validatePublishersOrReviewrs();
          if (response.schema) {
            that.rebuildForm.components = _.clone(response.schema.components);
            that.form = that.rebuildForm;
            that.onLoadFormType = response.schema?.display;
          }
          
          that.form.display = that.selectedformType != null ? _.toLower(this.selectedformType) : that.onLoadFormType == undefined ? "form" : that.onLoadFormType;
          that.selectedformType = that.selectedformType != null ? that.selectedformType : that.onLoadFormType != undefined ? _.startCase(_.toLower(that.onLoadFormType)) : "Form"
          that.form.page= 0;
          that.form.numPages= 1;
          that.blockedDocument = false;
          that.loading = false;
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error while fetching the application form",
            detail: error.message,
            life: 3000,
          });
          that.blockedDocument = false;
          that.loading = false;
        });
    },

    validatePublishersOrReviewrs() {
      let that = this;
      let loggedUser = that.$store.getters["login/getUser"];
      // console.log(loggedUser);
      if (that.selectedform !== null) {
        _.forEach(that.selectedform.application.publishers, function (item) {
          // if (item.email == that.selectedform.createdByUser.email) {
          if (item.email == loggedUser.email) {
            that.isFormCreaterAsPublisher = true;
          }
        });

        _.forEach(that.selectedform.application.reviewers, function (item) {
          // if (item.email == that.selectedform.createdByUser.email) {
          if (item.email == loggedUser.email) {
            that.isFormCreaterAsReviewer = true;
          }
        });
      }
    },
    statusConfirmation(name, msg) {
      let that = this;
      that.toastMsg = msg;
      that.selectedform = _.clone(that.$store.getters["forms/getSelectedForm"]);
      that.selectedAction = _.clone(name);
      that.displayConfirmation = true;
      switch (name) {
        case "requestForReview":
          that.confirmContent = `Are you sure, you want to Submit  the ${that.selectedform.name} form, If yes Enter Remarks`;
          break;
        case "requestForApproval":
          that.confirmContent = `Are you sure, you want to Accept  the ${that.selectedform.name} form, If yes Enter Remarks`;
          break;
        case "requestForReject":
          that.confirmContent = `Are you sure, you want to Reject the ${that.selectedform.name} form, If yes Enter Remarks`;
          break;
        case "requestForPublish":
          that.confirmContent = `Are you sure, you want to Publish the ${that.selectedform.name} form, If yes Enter Remarks`;
          break;
        default:
          break;
      }
    },
    closeConfirmation() {
      let that = this;
      that.submitted = false;
      that.displayConfirmation = false;
    },

    validateForm(str) {
      if (str == "request_for_publish" || str == "request_for_review") {
        if (this.remark) {
          this.form_error = true;
        } else {
          this.form_error = false;
        }
      } else if (str == "update_schema") {
        if (this.updateSchemaObj) {
          this.form_error = true;
        } else {
          this.form_error = false;
        }
      } else {
        this.form_error = true;
      }
    },
    showRevertBackDialog(){
      this.isRevertBack = true;
    },
    revertBackToPublishedForm(){
      let that = this;
      let form= {};
      form.formId = this.selectedFormId ? this.selectedFormId : this.formid;
      form.applicationId = this.selectedform.applicationId;
      that.blockedDocument = true;

      that.$store
        .dispatch("forms/revertBackToPublishedForm", form)
        .then(() => {
          let response = _.clone(that.$store.getters["forms/getPublishedForm"]);
          that.selectedform = _.clone(response);
          that.form = that.selectedform.schema;
          that.blockedDocument = false;
          this.getSelectedform();
          this.isRevertBack = false;  
          this.$toast.add({
          severity: "success",
          summary: "Success Message",
          detail: "Successfully reverted back to Pulished Form",
          life: 2000,
          });      
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error while fetching the application form",
            detail: error.response.data,
            life: 3000,
          });
        });
    },
  },
  props: {},
  watch: {},
};
</script>
<style scoped>
.formbuilderbtns {
  text-align: center;
  position: static;
}
.stickdiv{
  border: 1px solid #c8c8c8;
    border-radius: 3px;
    background-color: #e6e6e6;
}
.formbuilder {
  /* max-height: 537px;
  min-height: 537px; */
  height: 550px;
  overflow: hidden scroll;
  padding: 1%;
  background: #ffffff;
}
.active {
  background-color: #c8e6c9 !important;
  color: #256029 !important;
  border: #c8e6c9 !important;
}
.filter-width{
  width: 30%;
}
@media screen and (max-width: 1366px) and (max-height: 768px){
    /* Crazy CSS overrides here */
  .formbuilder {
  /* max-height: 537px;
  min-height: 537px; */
  height: 420px;
  overflow: hidden scroll;
  padding: 1%;
  background: #ffffff;
}
}
</style>
